import React from 'react';
import { isAlive } from 'mobx-state-tree';
import { observer } from 'mobx-react';
import { makeStyles } from 'tss-react/mui';
import { getContainingView } from '@jbrowse/core/util';
import { LoadingEllipses } from '@jbrowse/core/ui';
import { BlockMsg } from '@jbrowse/plugin-linear-genome-view';
var useStyles = makeStyles()(function (theme) {
  return {
    loading: {
      paddingLeft: '0.6em',
      backgroundColor: theme.palette.action.disabledBackground,
      backgroundImage: 'repeating-linear-gradient(45deg, transparent, transparent 5px, rgba(255,255,255,.5) 5px, rgba(255,255,255,.5) 10px)',
      height: '100%',
      width: '100%',
      pointerEvents: 'none',
      textAlign: 'center'
    }
  };
});
var Cloud = observer(function (_ref) {
  var model = _ref.model;
  var view = getContainingView(model);
  return React.createElement("canvas", {
    "data-testid": "ReadCloud-display-".concat(model.drawn),
    ref: function ref(_ref2) {
      if (isAlive(model)) {
        model.setRef(_ref2);
      }
    },
    style: {
      position: 'absolute',
      left: -view.offsetPx + model.lastDrawnOffsetPx,
      width: view.dynamicBlocks.totalWidthPx,
      height: model.height
    },
    width: view.dynamicBlocks.totalWidthPx * 2,
    height: model.height * 2
  });
});
export default observer(function (_ref3) {
  var model = _ref3.model;
  var view = getContainingView(model);
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var err = model.error;
  return err ? React.createElement(BlockMsg, {
    message: "".concat(err),
    severity: "error",
    buttonText: 'Reload',
    action: model.reload
  }) : model.loading ? React.createElement("div", {
    className: classes.loading,
    style: {
      width: view.dynamicBlocks.totalWidthPx,
      height: 20,
      position: 'absolute',
      left: Math.max(0, -view.offsetPx)
    }
  }, React.createElement(LoadingEllipses, {
    message: model.message
  })) : React.createElement(Cloud, {
    model: model
  });
});